import { FC, PropsWithChildren } from 'react';

import { AuthSocketProvider } from '@/shared/services/socket/auth.service';
import { CaseSocketProvider } from '@/shared/services/socket/case.service';
import { ChatSocketProvider } from '@/shared/services/socket/chat.service';

export const SocketProvider: FC<PropsWithChildren> = ({ children }) => {
  return (
    <AuthSocketProvider>
      <ChatSocketProvider>
        <CaseSocketProvider>{children}</CaseSocketProvider>
      </ChatSocketProvider>
    </AuthSocketProvider>
  );
};
